module.exports = __webpack_public_path__ + "static/media/Cats eyes 02_ENGELSKA-mixdown.4661b652.mp3";